export const PriceFormater = {
    priceToEuro : (price, sign=false) => {
        let signString = !sign || price === 0 ? '' : price > 0 ? '+ ' : '- ';
        let euroPrice = Math.abs(parseFloat((price / 100).toFixed(2)));
        return signString + euroPrice.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + ' €'
    }
}